// AUTO-GENERATED — do not edit. Source: /shared/. Run scripts/sync-shared.sh to update.
/**
 * Clean a service label for display (canonical, shared across all 3 apps — 2026-08-03).
 * The service catalog stores hierarchical names as "{Type} - {Variant}" (e.g.
 * "Classic Haircut - Short Classic"). Different booking paths saved either the full
 * name or just the variant, so the same cut shows two ways. This normalizes to the
 * meaningful tail — the part after the last " - " — for each service, and preserves
 * multi-service bookings joined with " + ".
 *   "Classic Haircut - Short Classic"                    -> "Short Classic"
 *   "Fade - Low Fade"                                     -> "Low Fade"
 *   "Short Classic"                                       -> "Short Classic"  (already clean)
 *   "Classic Haircut - Short Classic + Fade - Low Fade"  -> "Short Classic + Low Fade"
 * Display-only + non-destructive: stored data is untouched.
 */
export const formatServiceName = (service?: string | null): string => {
  if (!service) return '';
  return service
    .split(' + ')
    .map(part => {
      const segments = part.split(' - ');
      return segments[segments.length - 1].trim();
    })
    .filter(Boolean)
    .join(' + ')
    .trim();
};
